import { render } from "./PlatformIcon.vue?vue&type=template&id=c91a7174&scoped=true"
import script from "./PlatformIcon.vue?vue&type=script&lang=js"
export * from "./PlatformIcon.vue?vue&type=script&lang=js"

import "./PlatformIcon.vue?vue&type=style&index=0&id=c91a7174&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c91a7174"]])

export default __exports__